Drupal.behaviors.jcf = {
  attach: function (context, settings) {
   'use strict';

    jQuery(function() {
      jcf.replaceAll();
    });
  }
}
